import { z } from 'zod';

export const ResetPasswordFormInputSchema = z
  .object({
    newPassword: z
      .string()
      .min(8, 'Password must be at least 8 characters long')
      .refine(
        (password) => /[A-Z]/.test(password),
        'Password must contain at least one uppercase letter (A-Z)',
      )
      .refine(
        (password) => /[a-z]/.test(password),
        'Password must contain at least one lowercase letter (a-z)',
      )
      .refine(
        (password) => /[0-9]/.test(password),
        'Password must contain at least one number (0-9)',
      )
      .refine(
        (password) => !/([a-zA-Z0-9])\1{3,}/.test(password),
        'Password can not contain more than 3 repeated characters',
      ),
    confirmPassword: z.string(),
  })
  .refine((data) => data.confirmPassword === data.newPassword, {
    path: ['confirmPassword'],
    message: 'Passwords do not match',
  });
